import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
//import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import AnswerIcon from '../../components/AnswerIcon/AnswerIcon';
import QuizCounter from '../../components/QuizCounter/QuizCounter';

import ReactGA from 'react-ga';

import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

import Hoc from '../../hoc/hoc';
import Spinner from '../../components/UI/LoadingSpinner';
import classNames from 'classnames';
import classes from './Quiz.css';

class Quiz extends Component {

	state = {
		authToken:null,
		answered:false,
		activeQ: null,
		currentQnr: null,
		checked0:0,
		checked1:0,
		checked2:0,
		correctAnswers: []
	}


	componentWillReceiveProps(nextProps) {
		//console.log('quiz received props');
		if (nextProps.authToken!==this.state.authToken && nextProps.authToken) {

			//console.log("authtoken");
			this.setState({authToken:nextProps.authToken});
			this.props.onInitQuiz(nextProps.authToken,nextProps.userID);
		}

		if (nextProps.activeQuestion !== this.state.currentQnr && nextProps.quizStage==="started" && nextProps.authToken) {
			//console.log("shuffle questions");
			var cq = nextProps.pickedQuestions[nextProps.activeQuestion-1];
			var question = cq.q;
			var sArr = [1,2,3];
			sArr = this.shuffleArray(sArr);
			var answers = [];
			for (var n=0;n<3;n++) {
				answers.push(cq.a['answer'+sArr[n]]);
			}
			const newQ = {
				q: question,
				a: answers
			}
			//console.log('reached reset quiz state');
			this.setState({
				answered:false,
				checked0:0,
				checked1:0,
				checked2:0,
				currentQnr: nextProps.activeQuestion,
				activeQ: newQ,
			});
		}
		if (nextProps.quizStage==='finished') {
			this.cancelQuiz();
		}
	}


	prepQuiz = () => {
		this.props.onChangeQuizState('prep');
	}


	confirmScore = () => {

		ReactGA.event({
			category: 'Quiz Action',
			action: 'Score confirmed',
		});
		
		this.props.onConfirmQuizScore(this.props.quizSession,this.props.userID);
	}

	cancelQuiz = () => {

		ReactGA.event({
			category: 'Quiz Action',
			action: 'Score canceled',
		});

		this.props.onChangeQuizState('');
		this.props.history.push('/');
		this.props.onUpdatePath('/');
		this.props.onResetQuizState();
	}

	componentWillUnmount = () => {
		this.props.onResetQuizState();
	}

	shuffleArray(array) {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]]; // eslint-disable-line no-param-reassign
		}
		return array;
	}

	millisToMinutesAndSeconds(millis) {
		const minutes = Math.floor(millis / 60000);
		const seconds = ((millis % 60000) / 1000).toFixed(0);
		return (seconds === 60 ? (minutes+1) + ":00" : minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
	  }

	handleAnswerClick = (answer,order) => {
		const clickSt = this.state['checked'+order];
		//console.log(clickSt,order);
		let obj = {answered:true};
		if (clickSt===2) {
			obj['checked'+order]=false;
		} else if (clickSt===1 || clickSt===0) {
			obj['checked'+order]=true;
		}
		
		let newAnswerArr;
		newAnswerArr = [...this.state.correctAnswers];
		newAnswerArr[this.state.currentQnr-1] = Boolean(answer);
		//console.log('new answer Arr',newAnswerArr);
		obj.correctAnswers = newAnswerArr;
		this.setState(obj);
		//console.log('answer:',answer);
		//console.log('questions',this.props.activeQuestion, this.props.totalQuestions);
		ReactGA.event({
			category: 'Quiz Action',
			action: 'answer:' + answer,
		});
		if (this.props.activeQuestion < this.props.totalQuestions) {
			this.props.onQuizAnswer(this.props.quizSession,this.props.userID,'answer',answer);
		} else {
			this.props.onQuizAnswer(this.props.quizSession,this.props.userID,'end',answer);
		}
	};

	componentDidMount() {
		window.scrollTo(0, 0);
	}


	render () {

		let spin = null;
		if (this.props.spin) {
			spin = <Spinner/>
		}

		let q = "";
		let a = null;

		/* question bars */
		let barArr=[];
		let addStyles;
		for (let n=0;n<this.props.totalQuestions;n++) {
			//console.log('cor answ', this.state.correctAnswers[n])
			if (this.state.correctAnswers[n]===true) {
				addStyles = classes.answerLineGreen;
			} else if (this.state.correctAnswers[n]===false) {
				addStyles = classes.answerLineRed;
			} else {
				addStyles = null;
			}
			barArr.push(
				<div key={n} className={classNames(classes.answerBar, addStyles)} 
				></div>
			);
		}

		if (this.props.quizStage==="prep") {
			q = 'PRIPREMI SE!';
		} else if (this.props.quizStage==="init") {
			q = 'Želiš li da polažeš zabavni Durex ispit?';
			a = (
				<Hoc>
					<Button variant="contained" size="large" color="primary"
						onClick={this.prepQuiz}
					>
						DA, ŽELIM
					</Button>
					<Button variant="contained" size="large" color="secondary"
						onClick={this.cancelQuiz}
					>
						NE SADA
					</Button>
				</Hoc>
			);
		} else if (this.props.quizStage==='started') {
			a = (
				<div className={classes.pickedQuestions}>
					<div className={classes.singleAnswer}>
						<AnswerIcon 
							iconType={this.state.checked0}
							doClick={this.handleAnswerClick}
							order={0}
							answerText = {this.state.activeQ.a[0].text}
							correctness = {this.state.activeQ.a[0].value}
							disabled = {this.state.answered}
						/>
					</div>

					<div className={classes.singleAnswer}>
						<AnswerIcon 
							iconType={this.state.checked1}
							doClick={this.handleAnswerClick}
							order={1}
							answerText = {this.state.activeQ.a[1].text}
							correctness = {this.state.activeQ.a[1].value}
							disabled = {this.state.answered}
						/>
					</div>

					<div className={classes.singleAnswer}>
						<AnswerIcon 
							iconType={this.state.checked2}
							doClick={this.handleAnswerClick}
							order={2}
							answerText = {this.state.activeQ.a[2].text}
							correctness = {this.state.activeQ.a[2].value}
							disabled = {this.state.answered}
						/>
					</div>

				</div>
			)
			q = (this.state.activeQ.q);

		} else if (this.props.quizStage==='ended') {
			if (this.props.answers<=5) {

				q = (
					<div className={classes.congratsHolder}>
					Vaša ocena na Durex ispitu je <span className={classes.answerRed}>{this.props.answers}</span><br/>
					Sigurni smo da obožavate ovaj predmet, zato predlažemo da još malo obnovite gradivo udvoje i pokušate ponovo sutra.
					<br/><br/>
					Vreme za koje ste završili kviz je:<br/><br/><span className={classes.answerNumbers}>{this.millisToMinutesAndSeconds(parseInt(this.props.totalTime,10))}</span>
					</div>
				)
			} else if (this.props.answers>5 && this.props.answers<=8) {
				q = (
					<div className={classes.congratsHolder}>
					Položili ste ispit sa ocenom <span className={classes.answerBlue}>{this.props.answers}</span><br/>
					Vrlo dobro ste utvrdili materiju ispod pokrivača. Za desetku, preslišate još jednom u krevetu i pokušate sutra ponovo!
					<br/><br/>
					Vreme za koje ste završili kviz je:<br/><br/><span className={classes.answerNumbers}>{this.millisToMinutesAndSeconds(parseInt(this.props.totalTime,10))}</span>
					</div>
				)
			} else if (this.props.answers>8) {
				q = (
					<div className={classes.congratsHolder}>
					Čestitamo, dobili ste ocenu <span className={classes.answerGreen}>{this.props.answers}</span> na Durex ispitu!<br/>
					Odlično poznajete gradivo, što Vas čini neodoljivim! Praktično ste spremni da doktorirate!
					<br/><br/>
					Vreme za koje ste završili kviz je:<br/><br/><span className={classes.answerNumbers}>{this.millisToMinutesAndSeconds(parseInt(this.props.totalTime,10))}</span>
					</div>
				)

			}

			a = (
				<Hoc>
					<Button variant="contained" size="large" color="primary"
						onClick={this.confirmScore}
					>
						UPIŠI OCENU
					</Button>
					<Button variant="contained" size="large" color="secondary"
						onClick={this.cancelQuiz}
					>
						ODUSTANI
					</Button>
				</Hoc>
			);

		}

		//this.props.quizStage==="prep" ? 'Pripremi se!' : 'Želiš li da polažeš zabavni Durex ispit?'

		return (
			<div 
				className={classes.quiz} 
				location={this.props.curPath /* this.props.location.pathname */} 
			>
				<div className={classes.quizHolder}>
					<div style={{width:'100%',textAlign:'center'}} >
					{/*
						<img src='./durex-ispit.png'
							alt='Durex ispit'
							className={classes.imageTitle}
						/>
					*/}
						<h1 className={classes.h1Custom}>Durex ispit</h1>
					</div>					
					<Paper elevation={5} className={classes.paperHolder}>
						{this.props.quizStage==="prep" || this.props.quizStage==="started" ?
							(
								<div className={classes.leftColumn}>
									<QuizCounter/>
								</div>
							)
						:	null
						}
						<div className={classes.rightColumn}>
							{this.props.quizStage==="started" ?
								(
									<div className={classes.subHeaderSmaller}>
										{q}
									</div>
								) :
								(
									<div className={classes.subHeader}>
										{q}
									</div>
								)
							}
							{this.props.quizStage!=="prep" 
							? (
								<div className={this.props.quizStage==='ended' ? classes.answerHolderNoFlex : classes.answerHolder}>
									{a}
								</div>
							)
							: null
							}
							{this.props.quizStage==="started"
							? (
							<div className={classes.answerBarHolder}>
								{barArr}
							</div>
							)
							: null
							}
						</div>
					</Paper>
				</div>

				<div className={classes.SpinnerHolder}>
					{spin}
				</div>
			</div>
		);
	}
};


const mapStateToProps = state => {
	return {
		curPath: state.my.currentPath,
		quizStage: state.quiz.quizStage,
		spin: state.quiz.loading,
		activeQuestion: state.quiz.activeQuestion,
		pickedQuestions: state.quiz.pickedQuestions,
		authToken: state.auth.token,
		userID: state.auth.userId,
		quizSession: state.quiz.quizSession,
		totalQuestions: state.quiz.numberOfQuestions,
		answers: state.quiz.answers,
		totalTime: state.quiz.sessionTotalTime,
	};
}

const mapDispatchToProps = dispatch => {
	return {
		onUpdatePath: (newpath) => dispatch (actions.changePath(newpath)),
		onChangeQuizState: (newStage) => dispatch (actions.quizChangeStage(newStage)),
		onInitQuiz: (token,uid) => dispatch (actions.quizInitAction(token,uid)),
		onQuizAnswer: (qSess,uid,t,val) => dispatch (actions.quizPushAction(qSess,uid,t,val)),
		onUpdateModal: (modState, modWhat) => dispatch( actions.changeModal(modState, modWhat) ),
		onConfirmQuizScore: (qSess,uid) => dispatch( actions.quizConfirmScore(qSess, uid) ),
		onResetQuizState: () => dispatch ( actions.quizReset() ),
	}
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Quiz));


// WEBPACK FOOTER //
// ./src/containers/Quiz/Quiz.js